import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthorizationModel } from '../../models/authorization-model';

@Component({
  selector: 'ness-add-event-inline',
  templateUrl: './add-event-inline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddEventInlineComponent {
  @Output() showDataSlideout: EventEmitter<any> = new EventEmitter();
  private _authAgency: ServerModels.ENESS_REF_Agency = null;
  get authAgency(): ServerModels.ENESS_REF_Agency {
    return this._authAgency;
  }
  @Input() set authAgency(agency: ServerModels.ENESS_REF_Agency) {
    this._authAgency = agency;
    // resolves issue where agency is set after constructor and causes both add button and [Outside Agency] to appear
    if (agency && (!!agency.FieldDivisionID || !!agency.AgencyID)) {
      this._authOrgCode = this.currentUserType === 'ATFFieldDivision' ? this.authAgency.FieldDivisionID : this.authAgency.AgencyID;
      this.canCreate.authOrgCode = (this.hasNESSAdminRole || this.currentUserType === 'ATFHQ') ? null : this._authOrgCode;
    }
  }
  private _eventId: string = null;
  get eventId(): string {
    return this._eventId;
  }
  @Input() set eventId(id: string) {
    this._eventId = id;
  }
  @Output() scrollToRMSData: EventEmitter<string> = new EventEmitter();
  @Input() itemindex: number;

  readonly currentUserType: string = this.authService.userType.toString();
  readonly hasNESSAdminRole: boolean = this.authService.hasRole(['NESS Administrator']);
  private _authOrgCode: string = null;

  canCreate: AuthorizationModel = {
    role: [],
    userType: [],
    authOrgCode: (this.hasNESSAdminRole || this.currentUserType === 'ATFHQ') ? null : this._authOrgCode,
    roleUserType: [
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['Editor', 'Application Administrator', 'Power User', 'NESS Administrator'], userType: 'StateLocalLE' }
    ]
  } as AuthorizationModel;

  constructor(private authService: AuthService) { }

  public isOutsideAgency(): boolean {
    if (this.authService.hasRole(['NESS Administrator'])) {
      return false;
    } else {
      return (this.authService.hasUserType(['StateLocalLE']) ? !this.authService.hasOrgCode(this.authAgency?.AgencyID) :
        this.authService.hasUserType(['ATFFieldDivision']) && !this.authService.hasOrgCode(this.authAgency?.FieldDivisionID));
    }
  }
}
